import React from "react";
import { ArticuloPrecio, ArticuloPrecioHotSale, ArticuloPrecioMercado, } from "./PrecioProductoStyled";
var PrecioProducto = function (_a) {
    var moneda = _a.moneda, precio = _a.precio, _b = _a.variante, variante = _b === void 0 ? "common" : _b;
    var precioEntero = precio.toString().split(",")[0] || null;
    var precioDecimal = precio.toString().split(",")[1] || null;
    if (variante === "mercado") {
        return (React.createElement(ArticuloPrecioMercado, null,
            React.createElement("span", null, moneda),
            " ",
            precioEntero));
    }
    if (variante === "hotSale") {
        return (React.createElement(ArticuloPrecioHotSale, null,
            React.createElement("span", null, moneda),
            precioEntero));
    }
    return (React.createElement(ArticuloPrecio, null,
        React.createElement("span", null, moneda),
        precioEntero,
        " ",
        precioDecimal !== " " && React.createElement("sup", null,
            ".",
            precioDecimal)));
};
export default PrecioProducto;
